export enum SourceOfDomain {
    VerifyFinancialProfile = "verifyfinancialprofile.com"
}